<template>
  <article class="blog-saved-card">
    <router-link
      :to="postPath"
      class="blog-saved-card__link"
      :aria-label="`Abrir matéria: ${post.title || 'sem título'}`"
    >
      <div class="blog-saved-card__media">
        <img
          v-if="coverUrl"
          :src="coverUrl"
          :alt="post.title || 'Capa da matéria'"
          class="blog-saved-card__image"
          loading="lazy"
          decoding="async"
          width="640"
          height="400"
        />
        <div v-else class="blog-saved-card__placeholder" role="img" aria-label="Matéria sem imagem de capa">
          <v-icon large color="rgba(255, 255, 255, 0.35)">mdi-image-outline</v-icon>
        </div>
        <time v-if="formattedDate" class="blog-saved-card__date" :datetime="post.created_at">
          <v-icon x-small aria-hidden="true">mdi-calendar-clock</v-icon>
          <span>{{ formattedDate }}</span>
        </time>
      </div>

      <div class="blog-saved-card__body">
        <span v-if="!post.category" class="blog-saved-card__category blog-saved-card__category--archive">Arquivo</span>
        <span v-else class="blog-saved-card__category">{{ post.category.name }}</span>
        <h3 class="blog-saved-card__title">{{ post.title || "Matéria sem título" }}</h3>
        <p v-if="excerpt" class="blog-saved-card__excerpt">{{ excerpt }}</p>
        <div class="blog-saved-card__meta">
          <span class="blog-saved-card__meta-item">
            <v-icon small aria-hidden="true">mdi-heart-outline</v-icon>
            <span class="sr-only">Curtidas:</span>
            <span>{{ post.likes_count || 0 }}</span>
          </span>
          <span class="blog-saved-card__meta-item">
            <v-icon small aria-hidden="true">mdi-comment-outline</v-icon>
            <span class="sr-only">Comentários:</span>
            <span>{{ post.comments_count || 0 }}</span>
          </span>
        </div>
      </div>
    </router-link>

    <div class="blog-saved-card__footer">
      <button
        type="button"
        class="blog-saved-card__remove"
        :disabled="removing"
        :aria-label="`Remover dos salvos: ${post.title || 'matéria sem título'}`"
        @click="$emit('remove', post)"
      >
        <v-icon small aria-hidden="true">mdi-bookmark-remove-outline</v-icon>
        <span>{{ removing ? "Removendo…" : "Remover dos salvos" }}</span>
      </button>
    </div>
  </article>
</template>

<script>
import { socialMediaUrl } from "@/server/SocialService";

export default {
  name: "BlogSavedCard",
  props: {
    post: { type: Object, required: true },
    removing: { type: Boolean, default: false },
  },
  computed: {
    coverUrl() {
      return this.post.cover_image && this.post.cover_image.url
        ? socialMediaUrl(this.post.cover_image.url)
        : "";
    },
    formattedDate() {
      const value = this.post.created_at;
      if (!value) return "";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "";
      return new Intl.DateTimeFormat("pt-BR", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(date);
    },
    excerpt() {
      const content = this.post.content || "";
      const firstLine = content.split(/\r?\n/).map((line) => line.trim()).find((line) => line !== "");
      if (!firstLine) return "";
      const cleaned = firstLine
        .replace(/#[A-Za-zÀ-ÖØ-öø-ÿ0-9_-]+/g, "")
        .replace(/\s+/g, " ")
        .trim();
      if (cleaned.length <= 140) return cleaned;
      return `${cleaned.slice(0, 140).trimEnd()}…`;
    },
    postPath() {
      return { name: "BlogPost", params: { slug: this.post.slug }, query: { origem: "salvos" } };
    },
  },
};
</script>